import qmbg from "../../assets/img/qmbg.jpg"
import {toast} from "react-toastify";

/**
 * imgErr - Robust image error handler with retry and fallback logic
 *
 * Handles image loading failures by attempting multiple fallback strategies:
 * 1. Appends base64-encoded metadata as query param (bypasses cache)
 * 2. Retries up to 5 times with exponential backoff pattern
 * 3. Sets image to default placeholder (qmbg.jpg) after max retries
 * 4. Optionally marks image as failed in parent component's tracking Set
 *
 * Features 30-second timeout per attempt and proper cleanup of event handlers.
 *
 * @param {Event} e - Error event from img.onerror
 * @param {Object} data - Object containing meta or metadata with image field
 * @param {function} markImageAsFailed - Callback(data: string) to mark image in parent state
 */
export function imgErr(e, data, markImageAsFailed){

    if(!data?.meta && data?.metadata){
        data.meta = data.metadata;
    }

    let img = document.getElementById(e?.target?.id);
    if(img!==null) {
        if (!img?.rfcount) {
            img.rfcount = 0;
        }
        if (img.rfcount < 5) {
            img.rfcount++;

            let imageLoaded = false;

            const timer = setTimeout(() => {
                if (!imageLoaded) {
                    toast("Image loading cancelled due to timeout reached.")
                    img.rfcount = 5; // Set rfcount to 5 to trigger the else block on next error
                    imgErr(e, data, markImageAsFailed); // Re-call imgErr to handle the fallback
                }
            }, 30000); // 10-second timeout

            const handleLoad = () => {
                imageLoaded = true;
                clearTimeout(timer);
            };

            const handleError = () => {
                imageLoaded = true;
                clearTimeout(timer);
                // The browser's default error handling will re-trigger imgErr
            };

            img.onload = handleLoad;
            img.onerror = handleError;

            let newImg = "";

            if (data?.meta?.image) {
                newImg = btoa(data?.meta?.image);
            }
            img.src = img.src + "?" + newImg;
            //if(img?.rfcount===1) toast("Wait for IPFS")
        } else {
            if (markImageAsFailed) {
                markImageAsFailed(e.target.id);
            }
            img.src = qmbg
            img.onerror = null;
            img.onload = null;
        }
    }


    //console.log("IMGERR", e,data, cDat, img);

    //window.targetProxy_nft.push({target: e?.target?.id, data: data, cDat: cDat, ctrAddr: cDat?.contractAddress, net: cDat?.network, tokenId: data?.tokId, getMeta: true})
}
